import { render, staticRenderFns } from "./CustomerDetailNotes.vue?vue&type=template&id=49ce984a&scoped=true&"
import script from "./CustomerDetailNotes.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailNotes.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailNotes.vue?vue&type=style&index=0&id=49ce984a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce984a",
  null
  
)

export default component.exports